import React from 'react';
import { getLocalStorage, isUrl, setLocalStorage } from '../../../helpers/tools';
import $ from 'jquery';
import { vastSamples } from '../../../constants/Constants';
import { INIT_VAST_SAMPLE } from '../../../constants/Labels';

class VastForm extends React.Component {
  constructor(props) {
    super(props);
    setLocalStorage('vastSource', props.valueOfArea);
  }
  /**
   * Method to set the the initial state of textarea
   */
  onBlurArea = () => {
    const vastSource = $('#vast-source');

    this.props.onBlurArea.call(this, vastSource.val());
    setLocalStorage('vastSource', vastSource.val());

    if (vastSource.val() === '') {
      vastSource.val(this.props.initArea);
    }
    //setup correct vast sample select based on vast source value
    this.getVastSample();
  };

  /**
   * Method to empty the textarea on focus
   * @param {event} event
   */
  onFocusArea = event => {
    if (event.target.value === this.props.initArea) {
      event.target.value = '';
    }
  };

  /**
   * Method to disable or enable 'Share Link' button base on the textarea value
   */
  onChangeArea = () => {
    const vastSource = $('#vast-source').val();

    if (isUrl(vastSource)) {
      $('#button-share').removeClass('disabled');
      $('#button-apply').removeClass('disabled');
    } else {
      $('#button-share').addClass('disabled');
      $('#button-apply').addClass('disabled');
    }
  };

  /**
   * Handler for select value changed
   */
  onSelected = () => {
    const vastSampleSelect = $('#sample-selector option:checked')[0];
    const vastSampleArea = $('#vast-source');
    vastSampleArea.val(vastSamples[vastSampleSelect.value]);

    setLocalStorage('vastSample', vastSampleSelect.value);
    this.onChangeArea();
    this.onBlurArea();
  };

  /**
   * Method to get correct select option, it checks if vast source is one of defined samples
   * @return {string} select value from sample list or init value
   */
  getVastSample = () => {
    let vastSample = INIT_VAST_SAMPLE;
    const vastSource = getLocalStorage('vastSource') || $('vast-source').val();
    if (vastSource && isUrl(vastSource)) {
      vastSample =
        Object.keys(vastSamples).find(item => {
          return vastSamples[item] === vastSource;
        }) || INIT_VAST_SAMPLE;
    }

    setLocalStorage('vastSample', vastSample);
    return vastSample;
  };

  render() {
    const vastSample = this.getVastSample();
    return (
      <div>
        <div className="vastForm">
          <form>
            <div>VAST sample</div>
            <div>
              <select
                id="sample-selector"
                onChange={this.onSelected}
                defaultValue={vastSample}
                key={vastSample}
              >
                <option disabled>{INIT_VAST_SAMPLE}</option>
                {Object.keys(vastSamples).map(item => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>
          </form>
        </div>
        <div className="vastForm">
          <form>
            <div>VAST source</div>
            <div>
              <textarea
                id="vast-source"
                defaultValue={this.props.valueOfArea || this.props.initArea}
                key={this.props.valueOfArea}
                onFocus={this.onFocusArea}
                onBlur={this.onBlurArea}
                onChange={this.onChangeArea}
              />
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default VastForm;
